import { PropsWithChildren } from 'react'

import { passPropsToSingleChild } from '../render'
import { getView } from '../server'

export const ViewProvider = async ({ children }: PropsWithChildren) => {
  const viewValues = await getView()

  return passPropsToSingleChild(children, viewValues)
}
